/*
 * pp-topbar.js — Solo rotator de anuncios + cierre de submenu al click fuera.
 *
 * Self-guard contra doble bind via dataset.
 */
(function () {
  'use strict';

  if (document.documentElement.dataset.ppTopbarBound === '1') return;
  document.documentElement.dataset.ppTopbarBound = '1';

  /* Announcement rotator ──────────────────────────────────────────── */
  var rotator = document.querySelector('[data-pp-topbar-rotator]');
  if (rotator) {
    var slides = rotator.querySelectorAll('.pp-topbar__announcement');
    if (slides.length > 1) {
      var rotateMs = parseInt(rotator.getAttribute('data-rotate-ms') || '5000', 10);
      var idx = 0;
      setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, rotateMs);
    }
  }

  /* Avisos con etiqueta: pasan uno a uno hacia arriba ─────────────────── */
  var ticker = document.querySelector('[data-pp-topbar-ticker]');
  if (ticker) {
    var col = ticker.querySelector('.pp-topbar__avisos-col');
    var total = col ? col.children.length - 1 : 0; /* el último es copia del primero */
    if (total >= 1) {
      var tickMs = parseInt(ticker.getAttribute('data-rotate-ms') || '3500', 10);
      var k = 0;
      setInterval(function () {
        var h = col.firstElementChild.offsetHeight || 38;
        k++;
        col.classList.add('is-anim');
        col.style.transform = 'translateY(' + (-h * k) + 'px)';
        if (k === total) {
          setTimeout(function () {
            col.classList.remove('is-anim');
            col.style.transform = 'translateY(0)';
            k = 0;
          }, 520);
        }
      }, tickMs);
    }
  }

  /* Pop-up de temporada alta: lo abre el link del aviso (también desde la
     copia del ticker, por eso delegación). Cierra con ×, fondo, Entendido
     y ESC; regresa el foco a quien lo abrió. ───────────────────────────── */
  var temporada = document.querySelector('[data-pp-temporada-modal]');
  if (temporada) {
    // Al <body>: dentro del grupo del header queda debajo de la barra de
    // pestañas del celular (otro contexto de apilamiento) y tapa "Entendido".
    if (temporada.parentNode !== document.body) document.body.appendChild(temporada);
    var temporadaOpener = null;
    var abrirTemporada = function (opener) {
      temporadaOpener = opener || null;
      temporada.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var panel = temporada.querySelector('.pp-policy-modal__panel');
      if (panel) panel.focus();
    };
    var cerrarTemporada = function () {
      if (temporada.hidden) return;
      temporada.hidden = true;
      document.documentElement.style.overflow = '';
      if (temporadaOpener && temporadaOpener.focus) temporadaOpener.focus();
    };
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-pp-temporada-open]');
      if (open) { e.preventDefault(); abrirTemporada(open); return; }
      if (e.target.closest('[data-pp-temporada-close]')) cerrarTemporada();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarTemporada();
    });
  }

  /* Submenu aria-expanded toggle (hover ya lo maneja CSS) ─────────── */
  document.querySelectorAll('.pp-topbar__item--has-sub > .pp-topbar__link').forEach(function (trigger) {
    var parent = trigger.parentElement;
    parent.addEventListener('mouseenter', function () {
      trigger.setAttribute('aria-expanded', 'true');
    });
    parent.addEventListener('mouseleave', function () {
      trigger.setAttribute('aria-expanded', 'false');
    });
  });
})();
